import { auth, store, currentTimestampFirestore } from "./firebase";

class AuthenticationService {
  signupNewUser(form) {
    return auth.createUserWithEmailAndPassword(form.email, form.password);
  }

  createNewUser(userId, signupDetails) {
    return store
      .collection("users")
      .doc(userId)
      .set({
        id: userId,
        name: signupDetails.displayName,
        createdAt: currentTimestampFirestore,
        email: signupDetails.email,
        contact: signupDetails.phoneNumber,
        organisation: signupDetails.organisation,
        organisationId: signupDetails.organisationId,
        group: signupDetails.group,
        groupId: signupDetails.groupId,
        role: "user"
      });
  }

  getUser(userId) {
    return store
      .collection("users")
      .doc(userId)
      .get()
      .then(snapshot => {
        let user = snapshot.data();
        user.id = snapshot.id;
        return user;
      });
  }

  loginUser(form) {
    return auth.signInWithEmailAndPassword(form.email, form.password);
  }

  getUserAuth() {
    return auth.onAuthStateChanged(user => {
      return user;
    });
  }

  signoutUser() {
    return auth.signOut();
  }
}

export default new AuthenticationService();
